"use client";

import React from "react";
import { Users, Award, Shield } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  icon: Shield,
  title: "Pilar Ambiental",
  description: "Implementamos procesos de reciclaje avanzados y optimización de recursos para minimizar nuestra huella de carbono en la producción de acero."
}, {
  icon: Users,
  title: "Pilar Social",
  description: "Fomentamos el desarrollo integral de nuestros colaboradores y fortalecemos las comunidades locales mediante programas de educación y seguridad."
}, {
  icon: Award,
  title: "Pilar Económico",
  description: "Garantizamos la viabilidad a largo plazo a través de inversiones estratégicas en tecnología industrial y eficiencia operativa sostenible."
}];
export default function Sustainabilitypillars() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="263191" id="sustainabilitypillars" className="bg-background text-foreground py-20 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={headerReveal.ref} className={`mb-16 flex flex-col items-center text-center transition-all duration-700 ease-out ${headerReveal.isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="font-default text-foreground mb-4 text-3xl font-bold tracking-tight md:text-4xl lg:text-5xl">
            Nuestros Pilares de Sostenibilidad
          </h2>
          <p className="text-muted-foreground max-w-[800px] text-lg md:text-xl font-default">
            En Kalisch Acero, construimos el futuro sobre bases sólidas de responsabilidad y compromiso industrial.
          </p>
        </div>

        <div ref={gridReveal.ref} className={`grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-8 transition-all duration-1000 ease-out delay-200 ${gridReveal.isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <Card key={index} data-index={index} className="bg-card border-border shadow-md transition-all duration-300 hover:shadow-lg hover:border-primary/40 rounded-lg">
                <CardHeader className="pb-4">
                  <div className="bg-primary-100 text-primary mb-5 flex size-12 items-center justify-center rounded-lg">
                    <Icon className="size-6" />
                  </div>
                  <CardTitle className="font-default text-foreground text-xl font-bold leading-tight">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-muted-foreground text-base leading-relaxed font-default">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}